import classNames from 'classnames';
import {
  Button,
  FlexContainer,
  Input,
  Spinner,
  TitledBlock,
  Txt,
  ErrorMessage,
  InputImages,
} from 'components';
import { picturesMaxSize } from 'config';
import { observer } from 'mobx-react-lite';
import { useMemo, useState } from 'react';
import { useInventory, useProperty, useDataActions } from 'state';
import { inventoryDefault } from 'config/dataDefaults';
import InventoryAddEditState from './InventoryAddEditState';
import styles from './InventoryAddEditScreen.module.scss';
import { inventoryNotesField, inventoryTitleField } from 'config/fieldsProps';

/**
 * InventoryAddEditScreen
 *
 * @return {JSX.Element}
 */
const InventoryAddEditScreen = ({ className, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const propertyDoc = useProperty();
  const inventoryDoc = useInventory();
  const dataActions = useDataActions();
  const isEdit = !!inventoryDoc;

  const state = useMemo(
    () => new InventoryAddEditState(inventoryDoc?.data || inventoryDefault()),
    [inventoryDoc]
  );

  console.log('Inventory doc', inventoryDoc);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Submit');
    setIsLoading(true);
    try {
      await (isEdit
        ? dataActions.property.editInventory(
            propertyDoc,
            inventoryDoc,
            state.state
          )
        : dataActions.property.createInventory(propertyDoc, state.state));
      onClose();
    } catch (e) {
      setIsLoading(false);
      setError(e.message);
    }
  };

  const { state: dataState } = state;
  const handleChange = ({ target: { name, value } }) => {
    setError('');
    state.setState(name, value);
  };

  return (
    <FlexContainer
      className={classNames(
        styles.InventoryAddEditScreen,
        className,
        InventoryAddEditScreen.displayName
      )}
      column
      flex
      gap
    >
      <form onSubmit={handleSubmit}>
        <TitledBlock title="Title">
          <Input
            {...inventoryTitleField}
            fullWidth
            value={dataState.title || ''}
            onChange={handleChange}
            disabled={isLoading}
            reverse
            autoFocus
            enterKeyHint="next"
          />
        </TitledBlock>
        <TitledBlock title="Cost">
          <Input
            fullWidth
            type="number"
            min="1"
            max="50000"
            required
            name="itemCostAmount"
            value={dataState.itemCostAmount || ''}
            onChange={handleChange}
            disabled={isLoading}
            reverse
            enterKeyHint="next"
          />
        </TitledBlock>
        <TitledBlock title="Notes">
          <Input
            {...inventoryNotesField}
            fullWidth
            value={dataState.notes || ''}
            onChange={handleChange}
            disabled={isLoading}
            reverse
            enterKeyHint="next"
          />
        </TitledBlock>
        <TitledBlock title="Images">
          <InputImages
            name="imageUrls"
            value={dataState.imageUrls}
            onChange={handleChange}
            disabled={isLoading}
            multiple
            reverse
            resize={picturesMaxSize.property}
            enterKeyHint="enter"
          />
        </TitledBlock>
        {error ? <ErrorMessage small description={error} /> : null}
        <FlexContainer>
          <Button flex type="submit" big success disabled={isLoading}>
            {isLoading ? (
              <Spinner />
            ) : (
              <FlexContainer spaceBetween alignCenter flex>
                <Txt xx>{isEdit ? 'Update' : 'Add'} item</Txt>
                <Txt>🎉</Txt>
              </FlexContainer>
            )}
          </Button>
        </FlexContainer>
      </form>
    </FlexContainer>
  );
};

InventoryAddEditScreen.displayName = 'InventoryAddEditScreen';

export default observer(InventoryAddEditScreen);
